import axios from "axios";
import { SHOPIFY_DOMAIN } from "utils/constants";

const fetchCalendar = async (locationId) => {
	try {
		const response = await axios.get(`https://api-us.zapiet.com/v1.0/delivery/locations/${locationId}/calendar?shop=${SHOPIFY_DOMAIN}`);
		return response.data;
	} catch (err) {
		console.log("err fetching zapiet calendar", err);
		return { error: true };
	}
};

export default fetchCalendar;